export default __webpack_public_path__ + "8c64b7225d6f77f6869c50a95e04df53.jpg";